import steps from '@/configs/steps';

export default {
  namespaced: true,
  state: {
    items: [
      { text: steps.DONATION_AMOUNT, active: false },
      { text: steps.DONATION_INFO, active: false },
      { text: steps.DONATION_CONFIRM, active: false },
      { text: steps.DONATION_CARD_INFO, active: false },
      { text: steps.DONATION_SUCCESS, active: false },
    ],
  },
  mutations: {
    updateStep(state, step) {
      state.items.map(item => item.active = false);
      state.items[step].active = true;
    },
  },
};
